import Picker from '../picker'
import Panel from '../panel/time-select'

export default {
  mixins: [Picker],

  name: 'ElTimeSelect',

  componentName: 'ElTimeSelect',

  props: {
    type: {
      type: String,
      default: 'time-select'
    }
  },

  beforeCreate() {
    this.panel = Panel
  }
}



// WEBPACK FOOTER //
// ./src/public/components/el-date-picker/src/picker/time-select.js